import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { ButtonColor, ButtonDisplayType } from '@ftr/foundation'

@Component({
  selector: 'ftr-file-selector',
  templateUrl: './file-selector.component.html',
  styleUrls: ['./file-selector.component.css'],
})
export class FileSelectorComponent implements OnInit {
  @Input() enabled = true
  @Input() primary = true
  @Input() multiple = true
  @Input() label: string
  @Input() buttonDisplayType?: ButtonDisplayType
  @Input() acceptableFileExtensions: string[]
  @Output() fileAdded = new EventEmitter<File>()
  @ViewChild('fileInput') fileInput: ElementRef

  formattedFileExtensions: string = ''

  readonly buttonColor = ButtonColor
  buttonDisplayTypes = ButtonDisplayType

  ngOnInit(): void {
    this.formattedFileExtensions = this.acceptableFileExtensions.map(ext => `.${ext}`).join(',')
  }

  filesChanged($event: Event): void {
    const input = $event.target as HTMLInputElement

    if (input.files) {
      this.addNewFiles(Array.from(input.files))
    }
    // Clear value to allow the change event to fire if the user uploads the exact same files again
    input.value = ''
  }

  browseFiles($event: Event): void {
    $event.preventDefault()
    $event.stopPropagation()

    // Spoof a click event on the <input type='file'/> element
    const clickEvent = new MouseEvent('click', { bubbles: false })
    this.fileInput.nativeElement.dispatchEvent(clickEvent)
  }

  reset(): void {
    this.fileInput.nativeElement.value = null
  }

  private addNewFiles(files: File[]): void {
    if (!this.enabled) {
      return
    }

    files.map(file => this.fileAdded.emit(file))
  }
}
